import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class ResourceCenter extends BaseEntityModel {
  public id?: number;
  public companyId?: number;
  public englishUrl?: string;
  public frenchUrl?: string;

  constructor(model: Partial<ResourceCenter> = {}) {
    super(model);
    this.id = model.id;
    this.companyId = model.companyId;
    this.englishUrl = model.englishUrl;
    this.frenchUrl = model.frenchUrl;
  }
}
